import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { MentionedUser } from "@/entities/IDrop";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
export default function DropListItemContentMention(t0) {
  const $ = _c(6);
  const {
    user
  } = t0;
  const t1 = `/${user.handle_in_content}`;
  let t2;
  if ($[0] !== t1 || $[1] !== user.handle_in_content) {
    t2 = <Link onClick={_temp} href={t1} className="tw-align-middle tw-no-underline tw-font-medium tw-text-primary-400 desktop-hover:hover:tw-underline desktop-hover:hover:tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out">@{user.handle_in_content}</Link>;
    $[0] = t1;
    $[1] = user.handle_in_content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== user.mentioned_profile_id) {
    t3 = <UserProfileTooltipWrapper user={user.mentioned_profile_id}>{t2}</UserProfileTooltipWrapper>;
    $[3] = t2;
    $[4] = user.mentioned_profile_id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(e) {
  return e.stopPropagation();
}